import React from 'react';

const PLACEHOLDER_NAMES = new Set(['temporary user', 'n/a', 'na', 'unknown', 'none', '-', '']);

const cleanText = (v) => (v && typeof v === 'string' ? v.trim() : null);

export const formatPhone = (phone) => {
    if (!phone) return null;
    const digits = String(phone).replace(/\D/g, '');
    if (digits.length === 10) return `+91 ${digits.slice(0, 5)} ${digits.slice(5)}`;
    if (digits.length === 12) return `+${digits.slice(0, 2)} ${digits.slice(2, 7)} ${digits.slice(7)}`;
    return String(phone);
};

export const isPlaceholderName = (value) => {
    const clean = cleanText(value);
    return !clean || PLACEHOLDER_NAMES.has(clean.toLowerCase());
};

/**
 * Returns the best display name for a customer.
 * Falls back to business_name when the person name is absent,
 * then to the phone number, then to the provided fallback.
 */
export const getCustomerDisplayName = (name, businessName, phone, fallback = 'Unknown') => {
    const person = cleanText(name);
    if (!isPlaceholderName(person)) return person;
    const business = cleanText(businessName);
    if (!isPlaceholderName(business)) return business;
    return formatPhone(phone) || fallback;
};

/**
 * Returns a standardized display for a customer and their ID.
 * Format:
 * Customer Name
 * ID #<customer_id>
 * 
 * @param {Object} customer - An object containing customer properties.
 * @returns {React.ReactNode} The formatted display.
 */
export const getCustomerDisplay = (customer) => {
    if (!customer) return '—';
    
    // In some payloads it's customer_name, in others it's just name or customer
    const name = customer.customer_name || customer.name || customer.customer || 'Unknown Customer';
    const cId = customer.customer_id;
    
    if (cId !== undefined && cId !== null && cId !== '') {
        return (
            <div>
                <div className="font-weight-bold">{name}</div>
                <div className="small text-muted" style={{ fontSize: '0.75rem' }}>ID #{cId}</div>
            </div>
        );
    }
    
    return <div className="font-weight-bold">{name}</div>;
};
